import { Observable } from 'knockout';
import { WCCSliderItemState } from '../../enums/itemState';

export interface WCCSliderItemConfig<T> {
    data: T
}

export default abstract class WCCSliderItem<T> {
    abstract component: string

    state = ko.observable(WCCSliderItemState.justCreated);
    width = ko.observable<number>(0).extend({ deferred: true });
    height = ko.observable<number>().extend({ deferred: true });
    isActive = ko.observable(false);

    paddingLeft = ko.observable(0).extend({ deferred: true });
    paddingRight = ko.observable(0).extend({ deferred: true });
    marginLeft = ko.observable(0).extend({ deferred: true });
    marginRight = ko.observable(0).extend({ deferred: true });

    opacity = ko.observable(1);
    offset = ko.observable(0);

    data: Observable<T>    

    constructor(config: WCCSliderItemConfig<T>) {
        this.data = ko.observable(config.data);
    }

    getWidth(): number {
        return this.width();
    }
}